import type { ILearningModuleRepository } from '@/core/domain/learning/module/ILearningModuleRepository.ts'
import { LearningStatus } from '@/core/domain/resources/enums/LearningStatus.ts'
import { NabooContentLearningModule } from '@/core/domain/nabooContent/NabooContent.ts'

export class FetchNabooContentModuleUseCase {
  private learningModuleRepository: ILearningModuleRepository

  constructor(learningModuleRepository: ILearningModuleRepository) {
    this.learningModuleRepository = learningModuleRepository
  }

  async execute(
    learningModuleId: number,
    learningCourseId: number
  ): Promise<NabooContentLearningModule> {
    const learningModuleOptions = {
      withGrains: true,
      withSupports: true,
      withTask: true,
      status: [LearningStatus.Values.ACTIVE]
    }

    const learningModule = await this.learningModuleRepository.fetchLearningModule(
      learningCourseId,
      learningModuleId,
      learningModuleOptions
    )

    return new NabooContentLearningModule(learningModule)
  }
}
